import { prayerAndTalksConstants } from "./constants/prayerAndTalksConstant";

const prayerAndTalkSave = (prayerInput: any) => {
	return {
		type: prayerAndTalksConstants.prayerAndTalksSaveRequest,
		input: prayerInput
	};
};

const prayerAndTalkGetDetail = () => {
	return {
		type: prayerAndTalksConstants.prayerAndTalksDetailRequest,
	};
};

const prayerAndTalkGetChannel = () => {
	return {
		type: prayerAndTalksConstants.prayerAndTalksGetChannelRequest,
	};
};

export const prayerAndTalkAction = {
    prayerAndTalkSave,
    prayerAndTalkGetDetail,
    prayerAndTalkGetChannel
};